import { useMemo } from 'react';
import { GalleryAssetView } from 'app/views';

export default (asset, gallery) =>
  useMemo(() => new GalleryAssetView(asset, gallery), [asset, gallery]);
